import { Component, OnInit } from '@angular/core';
import { NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-home-carousel',
  templateUrl: './home-carousel.component.html',
  styleUrls: ['./home-carousel.component.scss'],
  providers: [NgbCarouselConfig],
})
export class HomeCarouselComponent implements OnInit {
  images = [
    '/assets/images/home/digital-id.gif',
    '/assets/images/home/carousel-slide-1.png',
    '/assets/images/home/carousel-slide-2.png',
    '/assets/images/home/carousel-slide-seasonal-halloween.png',
  ];

  constructor(config: NgbCarouselConfig) {}

  ngOnInit(): void {}
}
